<form [formGroup]="form">
  <div mat-dialog-actions>
    <h1 mat-dialog-title *ngIf="data.mode === 'create'">New cost override</h1>
    <h1 mat-dialog-title *ngIf="data.mode === 'edit'">Edit cost override</h1>
  </div>
  <mat-dialog-content flexLayout="row" flexLayoutGap="8px">
    <mat-form-field>
      <mat-label>Opinion Type</mat-label>
      <mat-select required [formControlName]="'caseTypeId'">
        <mat-option
          *ngFor="let caseType of data.allCaseTypes | async; trackBy: trackByFn"
          [value]="caseType.caseTypeId"
        >
          {{ caseType.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions [attr.align]="'end'">
    <button mat-flat-button [mat-dialog-close]="{ save: false }">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [mat-dialog-close]="{ save: true }"
      [disabled]="form.invalid"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
